import { getSesion } from './sesionAdmin';
import { reemplazarCon } from './navegar';

// El setter (Julio) solo tiene /admin/setting. Si cae en otra página del panel (un link viejo, el login de
// /admin/leads), se le manda allá en vez de dejarlo en "No tienes acceso" sin menú.
export const RUTA_SETTING = '/admin/setting';

export const esSetter = (sesion) => sesion?.rol === 'setter';

/** Tras un 403: si quien mira es setter, lo manda a /admin/setting y devuelve true. Nunca lanza. */
export const llevarSetterASetting = async () => {
  try {
    if (esSetter(await getSesion())) {
      reemplazarCon(RUTA_SETTING);
      return true;
    }
  } catch (e) {
    // Sin sesión legible no se redirige: la página muestra su error de siempre.
  }
  return false;
};

/** Tras el login: el rol viene en la respuesta. true si lo mandó a /admin/setting. */
export const setterAlEntrar = (datosLogin) => {
  if (!esSetter(datosLogin)) return false;
  reemplazarCon(RUTA_SETTING);
  return true;
};
